module.exports = __webpack_public_path__ + "static/owl-894a18d39223ef65bf586e31af309bd6.jpeg";